export class GetOperationQuery {
    private readonly _operationCode: string;

    constructor(operationCode: string) {
        this._operationCode = operationCode;
    }

    get operationCode(): string {
        return this._operationCode;
    }
}
